





















import { defineComponent } from '@vue/composition-api';

const name = 'ttam-empty-content';
export default defineComponent({
  name,
  props: {
    icon: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
    linkUrl: {
      type: String,
      default: 'javascript:;',
    },
  },
  setup(props, { emit }) {
    const onclick = () => {
      emit('click-link');
    };
    return {
      name,
      onclick,
    };
  },
});
